import { errorToast, getLocalStorageItem, isSuperAndSubAdmin, useOutsideClick } from '../../../utils/helper';
import React, { Fragment } from 'react';
import { useRef, useState, useEffect } from 'react';
import { Calendar } from 'react-date-range';
import SearchInput from '../../../component/common/Input/SearchInput';
import { Helmet } from 'react-helmet';
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/20/solid';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import Loader from '../../../component/common/Loader';
import Topbar2 from '../../PulseSurvey/Topbar';
import Pagination from '../../../component/common/Pagination/Pagination';
import ChallengesCard from '../../../component/common/cards/ChallengesCard';
import { ApiForRole } from './ApiForRole';
import { Api } from '../../../api';

const PAGE_SIZE = 9;
function ViewChallenges() {
  const location = useLocation();
  const selectedTheme = JSON.parse(localStorage.getItem('selectedTheme'));
   const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  const ref2 = useRef(null);
  const calendarRef = useRef(null);
  const [isOpen2, setIsOpen2] = useState(false);
  const [startDate, setStartDate] = useState();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [orderTypeis0, setorderTypeis0] = useState(null);
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const [challengesList, setChallengesList] = useState([]);
  const [selectedType, setSelectedType] = useState(0);
  const [isExpireValue, setIsExpireValue] = useState(false);

  // Helper function to determine API parameters
  const getApiParameters = (orderType, selectedType) => {
    let apiStatus = '';
    let isExpireStatus = false;
    let isActiveStatus = false;

    if (orderType === 11 || orderType === 10) {
      if (selectedType === 0) {
        apiStatus = 11; 
      } else if (selectedType === 1) {
        apiStatus = 10; 
      }
    } else if (orderType === 0) {
      if (selectedType === 3) {
        isExpireStatus = true;
        apiStatus = '';
      } else if (selectedType === 4) {
        apiStatus = 0;
        isExpireStatus = false;
      } else {
        apiStatus = '';
        isExpireStatus = false;
      }
    }
    else if(orderType === 1){
      apiStatus = 1;
      isActiveStatus = true;
    }

    return { apiStatus, isExpireStatus, isActiveStatus };
  };

  // Updated handleChangeType function with API call
  const handleChangeType = (val) => {
    setSelectedType(val);
    setCurrentPage(1); 
    
    const { apiStatus, isExpireStatus, isActiveStatus  } = getApiParameters(orderTypeis0, val);
    handlePagination(apiStatus, 1, PAGE_SIZE, searchTerm, startDate, isExpireStatus,isActiveStatus );
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const offerParam = queryParams.get('type');

    let orderType = null;
    if (offerParam === 'challenges') {
      orderType = 0;
      setSelectedType(2);
    } else if (offerParam === 'active') {
      orderType = 1;
    } else if (offerParam === 'templates') {
      orderType = 11;
      setSelectedType(0);
    }
    setorderTypeis0(orderType);
  }, [location.search]);

  const handlePagination = (status, pageNumber, totalCount, search, startDate, isExpire, isActive = false) => {
    setLoader(true);
    
    ApiForRole().getListChallenges(status, pageNumber, totalCount, search, startDate, isExpire, isActive).then(
      (response) => {
        if (response?.data?.challenges?.length > 0) {
          setCurrentPage(pageNumber);
          localStorage.removeItem("challengeStatus")
          setChallengesList(response?.data?.challenges);
          setTotalCount(response?.data?.pagination?.totalCount);
          setLoader(false);
        } else if (!(response?.data?.challenges?.length > 0)) {
          setChallengesList([]);
          setCurrentPage(1);
          setTotalCount(0);
          setLoader(false);
          errorToast("No challenge found");
        } else {
          setLoader(false);
        }
      }
    );
  };

  const handleChangeC = (e) => {
    const date = new Date(e);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    setStartDate(formattedDate);
    
    const { apiStatus, isExpireStatus, isActiveStatus  } = getApiParameters(orderTypeis0, selectedType);
    handlePagination(apiStatus, currentPage, PAGE_SIZE, searchTerm, formattedDate, isExpireStatus, isActiveStatus);
    setIsOpen2(false);
  };

  useOutsideClick(calendarRef, () => {
    setIsOpen2(false);
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const offerParam = queryParams.get('type');
    let isActiveForInitial = false;

    let passId = null;
    if (offerParam === 'challenges') {
      passId = '';
    } else if (offerParam === 'active') {
      passId = 1;
      isActiveForInitial = true;
    } else if (offerParam === 'templates') {
      passId = 11;
      setSelectedType(0);
    }
    handlePagination(passId, currentPage, PAGE_SIZE, searchTerm, startDate, isExpireValue, isActiveForInitial);
  }, []);

  // Handle search with debounce
  const handleSearch = (searchValue) => {
    const { apiStatus, isExpireStatus, isActiveStatus } = getApiParameters(orderTypeis0, selectedType);
    handlePagination(apiStatus, currentPage, PAGE_SIZE, searchValue, startDate, isExpireStatus, isActiveStatus);
  };

  return (
    <>
      <div className="relative lg:ps-5 lg:mb-[45px]">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Marketplace | Shoorah Admin</title>
        </Helmet>
        {loader ? <Loader /> : null}
        <Topbar2
          title={
            orderTypeis0 === 1
              ? ' Active Challenges'
              : (orderTypeis0 === 11 || orderTypeis0 === 10)
              ? 'Challenge Templates'
              : orderTypeis0 === 0
              ? ' Challenges'
              : ' Challenges'
          }
          infoBtn={false}
        />
      </div>

      <div className="relative lg:mb-[45px]">
        <div className="sm:flex flex-col md:flex-row justify-between items-center gap-3">
          {/* Left-aligned search input */}
          <div className="flex items-center justify-start sm:justify-center w-full sm:w-auto">
            <SearchInput
              id="searchKey"
              name="searchKey"
              type="text"
              onChange={(e) => {
                setSearchTerm(e.target.value);
                if (debounceTimeout) clearTimeout(debounceTimeout);
                const timeout = setTimeout(() => {
                  handleSearch(e.target.value);
                }, 500);
                setDebounceTimeout(timeout);
              }}
              placeholder="Search"
              className="w-full sm:w-auto px-3 py-2"
            />
          </div>

          {/* Right-aligned buttons */}
          <div className="flex flex-col sm:flex-row items-start sm:items-cente justify-center mt-2 sm:mt-0 space-y-2 sm:space-y-0 sm:space-x-2 w-full sm:w-auto">
            <div ref={ref2} className="relative inline-block text-left w-full sm:w-auto">
              <button
                type="button"
                onClick={() => setIsOpen2(!isOpen2)}
                className="flex justify-between items-center w-full sm:w-auto px-5 py-2 text-xs sm:text-base font-medium border dark:border-text-shoorah-darkBg border-[#0B1D2E] rounded-full dark:text-shoorah-darkBg dark:border-shoorah-darkBg"
              >
                <span>
                  {startDate ? `${new Date(startDate).toLocaleDateString()}` : 'Date Created'}
                </span>
                {selectedTheme ? (
                  <>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.2802 9.9668L12.9335 14.3135C12.4202 14.8268 11.5802 14.8268 11.0669 14.3135L6.72021 9.9668"
                        stroke="#F3F4F6"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </>
                ) : (
                  <>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.2802 9.9668L12.9335 14.3135C12.4202 14.8268 11.5802 14.8268 11.0669 14.3135L6.72021 9.9668"
                        stroke="#0B1D2E"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </>
                )}
              </button>
              {isOpen2 && (
                <div
                  className="absolute sm:-top-2 top-0 md:-left-60 sm:-left-40 left-0 w-full sm:w-auto transform scale-90 sm:scale-100 z-10 mt-1 p-2 bg-white shadow-lg ring-1 ring-[#E7EAE8] dark:bg-shoorah-darkBgColor rounded-md"
                  ref={calendarRef}
                >
                  <div className="bg-white dark:bg-shoorah-darkBgColor text-[14px]">
                    <Calendar
                      className={'calendar text-sm sm:text-lg'}
                      onChange={handleChangeC}
                      nextLabel={
                        <button className="custom-next-button flex justify-center items-center">
                          <ChevronRightIcon className="w-8 h-8" />
                        </button>
                      }
                      maxDate={new Date()}
                      prevLabel={
                        <button className="custom-prev-button flex justify-center items-center">
                          <ChevronLeftIcon className="w-8 h-8" />
                        </button>
                      }
                      date={startDate ? new Date(startDate) : new Date()}
                      navigationLabel={({ date }) => (
                        <button
                          style={{ cursor: 'default', pointerEvents: 'none' }}
                          className="text-base"
                        >
                          {date.toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}
                        </button>
                      )}
                    />
                  </div>
                </div>
              )}
            </div>

            <Link
              to={ userData?.slug ? `/${userData?.slug}/challenges/create-new-challenges?page=details&newchallenge=true` : '/challenges/create-new-challenges?page=details&newchallenge=true'}
              className="font-medium px-5 py-2 bg-shoorah-active text-white rounded-full w-full sm:w-auto xl:text-[16px] text-[14px]"
            >
              Create New Challenge
            </Link>
          </div>
        </div>
        {(orderTypeis0 === 10 || orderTypeis0 === 11) && (
          <div className="flex items-center h-full md:text-xl font-medium gap-6 text-shoorah-gray9 mt-8 ms-2">
            <button
              className={selectedType === 0 ? 'text-black dark:text-white' : ''}
              onClick={() => handleChangeType(0)}
            >
              Templates
            </button>
            {isSuperAndSubAdmin() &&
            <button
              className={selectedType === 1 ? 'text-black dark:text-white' : ''}
              onClick={() => handleChangeType(1)}
            >
              Draft
            </button>}
          </div>
        )}

        {(orderTypeis0 === 0) && (
          <div className="flex items-center h-full md:text-xl font-medium gap-6 text-shoorah-gray9 mt-8 ms-2">
            <button
              className={selectedType === 2 ? 'text-black dark:text-white' : ''}
              onClick={() => handleChangeType(2)}
            >
              All
            </button>
            <button
              className={selectedType === 3 ? 'text-black dark:text-white' : ''}
              onClick={() => handleChangeType(3)}
            >
              Expired
            </button>
            <button
              className={selectedType === 4 ? 'text-black dark:text-white' : ''}
              onClick={() => handleChangeType(4)}
            >
              Draft
            </button>
          </div>
        )}

        <div className="lg:mt-3 flex flex-col">
          {orderTypeis0 === 1 && (
            <ChallengesCard
              title="Active Challenges"
              onViewAllTap={() => navigate(userData?.slug ? `/${userData?.slug}/challenges/view-challenges?type=active` :'/challenges/view-challenges?type=active')}
              dataList={challengesList}
              view={false}
            />
          )}
          {orderTypeis0 === 0 && (
            <ChallengesCard
              title="Challenges"
              onViewAllTap={() => navigate(userData?.slug ? `/${userData?.slug}/challenges/view-challenges?type=challenges` : '/challenges/view-challenges?type=challenges')}
              dataList={challengesList}
              preview={true}
              view={false}
            />
          )}
          {(orderTypeis0 === 11 || orderTypeis0 === 10) && (
            <ChallengesCard
              title="Challenge Templates"
              onViewAllTap={() => navigate(userData?.slug ? `/${userData?.slug}/challenges/view-challenges?type=templates` : '/challenges/view-challenges?type=templates')}
              dataList={challengesList}
              preview={true}
              view={false}
            />
          )}
        </div>

        <div>
          {challengesList.length > 0 && !loader ? (
            <Pagination
              currentPage={currentPage}
              totalCount={totalCount}
              pageSize={PAGE_SIZE}
              onPageChange={(page) => {
                const { apiStatus, isExpireStatus,isActiveStatus  } = getApiParameters(orderTypeis0, selectedType);
                handlePagination(apiStatus, page, PAGE_SIZE, searchTerm, startDate, isExpireStatus, isActiveStatus);
              }}
            />
          ) : (
            <span />
          )}
        </div>
      </div>
    </>
  );
}

export default ViewChallenges;